var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { validateEmail } from '../../common';
import { isNotIncludedEmailDomain } from '../../utils';
import { validateAccountStatus } from './proffit_search_common_validate';
export const proffitSearchAccountAssignValidate = {
    email: [
        ...validateEmail,
        (value, record, props) => {
            const { enableMembers, initialValues } = props;
            // 初期値と同じ場合は重複エラーの対象外にする
            if (value === initialValues.email) {
                return '';
            }
            return enableMembers.some((v) => v.email === value)
                ? '既に登録されているメールアドレスです'
                : '';
        },
        (value, record, props) => {
            const { enableDomains } = props;
            return isNotIncludedEmailDomain(enableDomains, 'ドメインが異なるメールアドレスは登録できません')(value);
        },
    ],
    form: (values, dispatch, formProp, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
        const { changeEmailStates, initialValues, unmountRef } = formProp;
        if (fieldName) {
            const email = values[fieldName];
            // メールアドレスが入力されていない、もしくは初期表示と変わらない場合は非同期バリデーションを行わない
            if (!email || email === initialValues.email) {
                return;
            }
            const result = yield validateAccountStatus(dispatch, email, fieldName);
            if (unmountRef.current) {
                return;
            }
            const updateEnableStates = {};
            if (result.hasEnableAccount) {
                updateEnableStates[result.email] = true;
            }
            const updateError = {};
            if (result.error) {
                updateError[fieldName] = result.error;
            }
            changeEmailStates(updateEnableStates);
            if (Object.keys(updateError).length > 0) {
                throw updateError;
            }
        }
    }),
};
export default proffitSearchAccountAssignValidate;
